var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('table',{staticClass:"table is-fullwidth no-border"},[_c('tbody',[_vm._l((_vm.items),function(item){return [_c('tr',[_c('td',[_vm._v(_vm._s(item.permit))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.created_at))])])]})],2)])])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1551c594","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./Modules/MobileFoodVendor/Resources/assets/js/components/Checkedin.vue
// module id = +Vef
// module chunks = 0